import Dashboard from './pages/Dashboard/Dashboard';
import './App.css';
import Navbar from './components/Navbar/Navbar';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Login from './pages/login/Login';
import Register from './pages/Register/Register'; // Uncomment if you have a Register page 

function App() {
  return (
    <BrowserRouter>
      <Navbar />
      <Routes>
        <Route path="/Dashboard" element={<Dashboard />} />
          <Route path="/" element={<Dashboard />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
